import React from 'react'

import { formField } from 'decorators'

import FileDropzone from './FileDropzone'

export default formField(props => <FileDropzone {...props} />)
